module.exports = __WEBPACK_EXTERNAL_MODULE_openfl_text_TextFormat__;